import PillButton from 'approot/shared/pills/pill-button';
import { ActionButtonWrapper as ActionButtonWrapperStyled } from './action-button.style';

export type ButtonProps = {
  title: string;
  ariaLabel: string;
  backgroundColour?: string;
  onClick?: Function;
};

type WrapperProps = {
  buttons: ButtonProps[];
};

export const ActionButtonWrapper = ({ buttons }: WrapperProps) => {
  return (
    <ActionButtonWrapperStyled data-selector="button-wrapper">
      {buttons.map((button, index) => {
        return (
          <PillButton
            key={index}
            onClick={() => button.onClick && button.onClick()}
            aria-label={button.ariaLabel || `Button to ${button.title}`}
          >
            {button.title}
          </PillButton>
        );
      })}
    </ActionButtonWrapperStyled>
  );
};
